<ion-app>
  <main class="main-root sc-dark-theme">
    <router-outlet class="router-outlet"></router-outlet>
    <app-overlay class="overlay"></app-overlay>
  </main>
</ion-app>
